import {
    getOCSFSeverityNameFromNumber,
} from "core/utils/common";
import {
    convertUnixTimeToDate,
} from  "core/utils/dateTimeUtils";

export const getCasesMetricsMapper = (t, metrics) => {
    const response_obj = [
        { num: metrics["totalCount"], type: t("TOP_GRID_BOX.TOTAL_CASES"), color: "fff" },
        { num: 0, type: t("TOP_GRID_BOX.CRITICAL"), color: "fff" },
        { num: 0, type: t("TOP_GRID_BOX.HIGH"), color: "fff" },
        { num: 0, type: t("TOP_GRID_BOX.MEDIUM"), color: "fff" },
        { num: 0, type: t("TOP_GRID_BOX.LOW"), color: "fff" },
        { num: 0, type: t("TOP_GRID_BOX.INFORMATIVE"), color: "fff" },
    ]

    const temp = Object.entries(metrics["severities"]).map(([key, value]: [string, number]) => {
    const severityOCSFName: string = getOCSFSeverityNameFromNumber(t, parseInt(key));
    response_obj.map((object) => {      
            if (object["type"] === severityOCSFName) {
                object.num = value
            }
        })
    });

    return response_obj;
};

export const getCommentsResponseMapper = (t, data) => {
    const temp = data.map((comment) => {
        return {
        firstName: comment[0],
        lastName: comment[1],
        userEmail: comment[2],
        postedOn: convertUnixTimeToDate(comment[3]),
        commentText: comment[4],
        commentId: comment[5]
        }
    });
    return temp
};